import {
  VERFY_SIGUP_OTP_REQUEST,
  VERFY_SIGUP_OTP_SUCCESS,
  VERFY_SIGUP_OTP_FAILURE,
  VERFY_SIGUP_OTP_EMPTY,
} from "../../../Utils/Constant";

const initialState = {
  data: null,
  loading: false,
  error: null,
  info: null,
};
export const verifyRegisterOtpReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case VERFY_SIGUP_OTP_REQUEST:
      return {
        ...state,
        data: action.payload,
        loading: true,
        error: null,
      };
    case VERFY_SIGUP_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        info: action.payload,
        error: null,
      };
    case VERFY_SIGUP_OTP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case VERFY_SIGUP_OTP_EMPTY:
      return {
        ...state,
        data: null,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};
